export default {"LABEL":"Disciplines 设计原则","DESC":"","COMPONENTS":{"__markdown":true}}